import React, { useEffect } from 'react';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Grid from '@mui/material/Unstable_Grid2';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import axios from "axios";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

export default function DialogoEditar(props) {
  const [nombre, setNombre] = React.useState('');
  const [nombreError, setNombreError] = React.useState('');
  const [app, setApp] = React.useState('');
  const [appError, setAppError] = React.useState('');
  const [apm, setApm] = React.useState('');
  const [apmError, setApmError] = React.useState('');
  const [usuario, setUsuario] = React.useState('');
  const [usuarioError, setUsuarioError] = React.useState('');
  const [estado, setEstado] = React.useState(1);

  const handleClose = () => {
    props.setOpen(false)
  };  

  useEffect(() => {    
    setNombre(props.arrayDatos.nombres);
    setApp(props.arrayDatos.aPaterno);
    setApm(props.arrayDatos.aMaterno);
    setUsuario(props.arrayDatos.usuario);
    setEstado(props.arrayDatos.estado); 
  }, []);

  function guardar(){        
    props.setDialogNotificacionOpen(true);
    props.setDialogNotificacionTipo('Carga');
    props.setDialogNotificacionMensaje('');

    var ban = 0;

    if (nombre === "") { setNombreError('error'); ban = 1; } else { setNombreError(''); }
    if (app === "") { setAppError('error'); ban = 1; } else { setAppError(''); }
    if (apm === "") { setApmError('error'); ban = 1; } else { setApmError(''); }
    if (usuario === "") { setUsuarioError('error'); ban = 1; } else { setUsuarioError(''); }

    if(ban === 0){
      axios.post(props.ruta + "backend/usuarios/eliminar.php", {
          userId: props.userArray.id,
          id: props.arrayDatos.id,
          nombre: nombre,
          app: app,
          apm: apm,
          usuario: usuario
      })
      .then(result => {
          var data = result.data;

          if (data[0].error === 0) {
            props.setDialogNotificacionOpen(false);
            props.getDatos();
            props.setOpen(false);
          } else {
            props.setDialogNotificacionTipo('Error');
            props.setDialogNotificacionMensaje("Se ha producido un error al momento de guardar, tome una captura de pantalla y contacte al administrador");
          }

      });      
    } else if(ban === 1){
      props.setDialogNotificacionTipo('Alerta');
      props.setDialogNotificacionMensaje('No se aceptan campos vacios');
    }
  }

  return (
    <React.Fragment>
      <BootstrapDialog
        aria-labelledby="customized-dialog-title"
        open={props.open}
        maxWidth='xl'
        fullWidth={true}
      >        
        <DialogTitle id="alert-dialog-title" style={{backgroundColor: '#a31545', color: '#ffffff', textAlign: 'center'}}>
          <Typography variant="h5" style={{textAlign: 'center'}}>
            ¿Seguro que deseas eliminar este usuario?
          </Typography> 
        </DialogTitle>
        <DialogContent dividers>
          <Grid container spacing={2} justifyContent={'center'}>
            <Grid item xs={12} md={2}>
              <TextField id="nombre" label="Nombre" variant="outlined" style={{width:'100%'}}               
                value={nombre}
                disabled
                onChange={(event) => setNombre(event.target.value)}
                error={nombreError}
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <TextField id="app" label="A. Paterno" variant="outlined" style={{width:'100%'}}               
                value={app}
                disabled
                onChange={(event) => setApp(event.target.value)}
                error={appError}
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <TextField id="apm" label="A. Materno" variant="outlined" style={{width:'100%'}}               
                value={apm}
                disabled
                onChange={(event) => setApm(event.target.value)}
                error={apmError}
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <TextField id="usuario" label="Usuario" variant="outlined" style={{width:'100%'}}               
                value={usuario}
                disabled
                onChange={(event) => setUsuario(event.target.value)}
                error={usuarioError}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} variant="contained" style={{backgroundColor: '#a31545', color: '#ffffff'}}>
            Cancelar
          </Button>
          <Button onClick={guardar} variant="contained" style={{backgroundColor: '#082342', color: '#ffffff'}}>
            Aceptar
          </Button>
        </DialogActions>
      </BootstrapDialog>
    </React.Fragment>
  );
}